import React, { useEffect, useMemo, useState } from "react";
import api from "../services/api";

function CreateAdmin({ setPage }) {
  const [firstName,setFirstName] = useState("");
  const [lastName,setLastName] = useState("");
  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [status,setStatus] = useState("active");

  const [products,setProducts] = useState({
    lms:true,
    live:false
  });

  const [industries,setIndustries] = useState([]);
  const [courses,setCourses] = useState([]);

  const [selectedIndustries,setSelectedIndustries] = useState([]);
  const [selectedCourses,setSelectedCourses] = useState([]);

  useEffect(()=>{
    loadIndustries();
    loadCourses();
  },[]);

  const loadIndustries = async () => {
    try {
      const res = await api.get("/industries");
      setIndustries(res.data.data || []);
    } catch(err) {
      console.log("Industry load error",err);
    }
  };

  const loadCourses = async () => {
    try {
      const res = await api.get("/courses");
      setCourses(res.data.data || []);
    } catch(err) {
      console.log("Course load error",err);
    }
  };

  const toggleIndustry = (industryId) => {
    const id = String(industryId);

    setSelectedIndustries(previous => {
      const exists = previous.some(value => String(value) === id);

      if (exists) {
        // Removing an industry also removes courses belonging to it.
        setSelectedCourses(courseIds =>
          courseIds.filter(courseId => {
            const course = courses.find(
              item => String(item.id) === String(courseId)
            );

            return !course || String(course.industry_id) !== id;
          })
        );

        return previous.filter(value => String(value) !== id);
      }

      return [...previous, industryId];
    });
  };

  const toggleCourse = (courseId) => {
    const id = String(courseId);

    setSelectedCourses(previous => {
      const exists = previous.some(value => String(value) === id);

      if (exists) {
        return previous.filter(value => String(value) !== id);
      }

      return [...previous, courseId];
    });
  };

  const visibleCourses = useMemo(() => {
    if (!products.lms || !selectedIndustries.length) {
      return [];
    }

    const selected = new Set(
      selectedIndustries.map(value => String(value))
    );

    return courses.filter(course =>
      selected.has(String(course.industry_id))
    );
  }, [courses, selectedIndustries, products.lms]);

  const updateProduct = (key, checked) => {
    setProducts(previous => ({
      ...previous,
      [key]: checked
    }));

    if (key === "lms" && !checked) {
      setSelectedCourses([]);
    }
  };

  const createAdmin = async () => {
    if(!firstName.trim()){
      alert("First name required");
      return;
    }

    if(!email.trim()){
      alert("Email required");
      return;
    }

    if(!products.lms && !products.live){
      alert("Select MaAz LMS, MaAz Live, or both");
      return;
    }

    if(selectedIndustries.length === 0){
      alert("Select at least one industry");
      return;
    }

    if(products.lms && selectedCourses.length === 0){
      alert("Select at least one LMS course");
      return;
    }

    try {
      await api.post("/admins",{
        first_name:firstName,
        last_name:lastName,
        email,
        password,
        industries:selectedIndustries,
        courses: products.lms ? selectedCourses : [],
        status,
        product_access: products
      });

      alert("Admin created successfully");
      setPage({page:"admins"});

    } catch(err) {
      console.log(err);
      alert(
        err?.response?.data?.message ||
        "Failed to create admin"
      );
    }
  };

  return(
    <div style={{padding:"30px",maxWidth:"900px"}}>
      <h2 style={{marginBottom:"25px"}}>Create Admin</h2>

      <div style={card}>
        <form autoComplete="off"></form>

        <input type="text" style={{display:"none"}} autoComplete="username"/>
        <input type="password" style={{display:"none"}} autoComplete="new-password"/>

        <input
          placeholder="First Name"
          value={firstName}
          onChange={(e)=>setFirstName(e.target.value)}
          style={input}
        />

        <input
          placeholder="Last Name (optional)"
          value={lastName}
          onChange={(e)=>setLastName(e.target.value)}
          style={input}
        />

        <input
          placeholder="Email"
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
          style={input}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e)=>setPassword(e.target.value)}
          style={input}
        />

        <select
          value={status}
          onChange={(e)=>setStatus(e.target.value)}
          style={input}
        >
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      {/* PRODUCT ACCESS */}
      <div style={card}>
        <h3 style={{marginBottom:"8px"}}>Product Access</h3>

        <p style={{color:"#666",marginTop:0}}>
          Choose whether this Admin can access LMS, Live, or both from MaAz Platform.
        </p>

        <div style={{display:"flex",gap:"28px",marginTop:"16px"}}>
          <label style={industryItem}>
            <input
              type="checkbox"
              checked={products.lms}
              onChange={(e)=>updateProduct("lms",e.target.checked)}
              style={{marginRight:"8px"}}
            />
            MaAz LMS
          </label>

          <label style={industryItem}>
            <input
              type="checkbox"
              checked={products.live}
              onChange={(e)=>updateProduct("live",e.target.checked)}
              style={{marginRight:"8px"}}
            />
            MaAz Live
          </label>
        </div>
      </div>

      {/* INDUSTRIES */}
      <div style={card}>
        <h3 style={{marginBottom:"8px"}}>Industries</h3>

        <p style={{color:"#666",marginTop:0}}>
          Select the industries this Admin is allowed to manage.
        </p>

        <div style={industryGrid}>
          {industries.map(industry => (
            <label key={industry.id} style={industryItem}>
              <input
                type="checkbox"
                checked={selectedIndustries.some(
                  value => String(value) === String(industry.id)
                )}
                onChange={()=>toggleIndustry(industry.id)}
                style={{marginRight:"8px"}}
              />
              {industry.name}
            </label>
          ))}
        </div>
      </div>

      {/* COURSE ACCESS */}
      {products.lms && (
        <div style={card}>
          <h3 style={{marginBottom:"8px"}}>Course Access</h3>

          <p style={{color:"#666",marginTop:0}}>
            Select the LMS courses this Admin can preview. Courses are shown only
            from the selected industries.
          </p>

          {!selectedIndustries.length ? (
            <div style={emptyBox}>
              Select an industry first to view its courses.
            </div>
          ) : visibleCourses.length === 0 ? (
            <div style={emptyBox}>
              No courses are available for the selected industries.
            </div>
          ) : (
            <div style={courseGrid}>
              {visibleCourses.map(course => (
                <label key={course.id} style={courseItem}>
                  <input
                    type="checkbox"
                    checked={selectedCourses.some(
                      value => String(value) === String(course.id)
                    )}
                    onChange={()=>toggleCourse(course.id)}
                    style={{marginRight:"9px"}}
                  />

                  <div>
                    <strong>{course.title}</strong>

                    <div style={courseIndustry}>
                      {course.industry_name || "Selected Industry"}
                    </div>
                  </div>
                </label>
              ))}
            </div>
          )}

          <div style={selectionSummary}>
            Selected courses: <strong>{selectedCourses.length}</strong>
          </div>
        </div>
      )}

      <div style={{marginTop:"20px"}}>
        <button
          style={primaryBtn}
          onClick={createAdmin}
        >
          Create Admin
        </button>

        <button
          style={cancelBtn}
          onClick={()=>setPage({page:"admins"})}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

const card={
  background:"#fff",
  padding:"25px",
  borderRadius:"8px",
  boxShadow:"0 2px 10px rgba(0,0,0,0.08)",
  marginBottom:"25px"
};

const input={
  width:"100%",
  padding:"10px",
  marginBottom:"12px",
  border:"1px solid #ddd",
  borderRadius:"6px"
};

const industryGrid={
  display:"grid",
  gridTemplateColumns:"1fr 1fr",
  gap:"10px"
};

const industryItem={
  display:"flex",
  alignItems:"center",
  padding:"6px 0"
};

const courseGrid={
  display:"grid",
  gridTemplateColumns:"1fr 1fr",
  gap:"12px",
  marginTop:"18px"
};

const courseItem={
  display:"flex",
  alignItems:"flex-start",
  border:"1px solid #e3e6e8",
  borderRadius:"8px",
  padding:"13px",
  cursor:"pointer",
  background:"#fafafa"
};

const courseIndustry={
  fontSize:"12px",
  color:"#777",
  marginTop:"4px"
};

const emptyBox={
  padding:"16px",
  marginTop:"15px",
  background:"#f7f7f7",
  border:"1px dashed #ccc",
  borderRadius:"8px",
  color:"#666"
};

const selectionSummary={
  marginTop:"18px",
  fontSize:"13px",
  color:"#555"
};

const primaryBtn={
  background:"#2c3e50",
  color:"#fff",
  padding:"10px 18px",
  border:"none",
  borderRadius:"6px",
  marginRight:"10px",
  cursor:"pointer"
};

const cancelBtn={
  background:"#f4f4f4",
  color:"#333",
  padding:"10px 18px",
  border:"1px solid #ccc",
  borderRadius:"6px",
  cursor:"pointer"
};

export default CreateAdmin;
